const baseUrl = "https://wenjuantest.kuaikaoshi.top/prod-api"
//const baseUrl = "https://www.wjguanjia.com/prod-api"
//const baseUrl = "https://beattest.wjguanjia.com/prod-api"

export default baseUrl


// WEBPACK FOOTER //
// ./src/utils/bsaeUrl.js